export default {
  point: 0,
  __typename: 'Points'
};
